const MENU_KEY_PATTERN = /^[a-z0-9][a-z0-9_-]{0,63}$/

export function slugifyMenuKey(name: string): string {
  const base = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-+/g, '-')
  if (!base) return 'item'
  return base.slice(0, 64)
}

export function isValidMenuKey(key: string): boolean {
  return MENU_KEY_PATTERN.test(key)
}

/** Pick a unique key from name, adding -2, -3, … against taken set. */
export function dedupeMenuKey(base: string, taken: Set<string>): string {
  const slug = slugifyMenuKey(base)
  if (!taken.has(slug)) return slug
  for (let n = 2; n < 1000; n++) {
    const suffix = `-${n}`
    const candidate = `${slug.slice(0, Math.max(1, 64 - suffix.length))}${suffix}`
    if (!taken.has(candidate)) return candidate
  }
  return `${slug}-${Date.now()}`
}

export function optionIdFromLabel(label: string, index: number): string {
  const fromLabel = slugifyMenuKey(label || `option-${index + 1}`)
  return fromLabel.startsWith('opt-') ? fromLabel : `opt-${fromLabel}`
}
